import { rgba } from "polished";
import React from "react";
import { useParams, withRouter } from "react-router-dom";
import styled from "styled-components/macro";
import { useFormikContext } from "formik";
import { rem } from "polished";
import { ReactComponent as OkIcon } from "../../../assets/icons/PostcodeOk.svg";
import media from "../../../theme/media";

import ExitContentEvr from "../../../components/ExitContentEvr";
import SupportServices from "../../../components/SupportServices";
import { FlatApplciationType } from "../../../types";
import { protectedPersonRoles } from "../constants";
import Info from "../../../components/Info";
import getCourtById from "../../../helpers/getCourtById";

const ReDecalreComplete: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  const { values, setFieldValue } = useFormikContext<FlatApplciationType>();
  const courtName = getCourtById(values.CourtID)?.name || "your local court";

  React.useEffect(() => {
    setFieldValue("Status", "re-declare-accepted");
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Inner>
        <Main>
          <SuccessBox>
            <OkIcon />
            <div>
              <h2>
                Your application has been submitted, but no changes have been made to the intervention order at this stage.
              </h2>
              <p>
                Your reference number is {id}. It may be useful as a reference, so keep it somewhere safe.
              </p>
            </div>
          </SuccessBox>
          <h2>What happens next?</h2>
          <ExitContentEvr
            isProtectedPerson={values.seeking === "appl" && protectedPersonRoles.includes(String(values.seeking_appl_role))}
            courtName={courtName}
          />
         <h2>Family violence support services</h2>
          <p>
            If you need help completing this application, contact your{" "}
            <Info
              displayText="local court"
              headingText="Your local court"
              bodyText='<a href="https://www.mcv.vic.gov.au/going-court/find-court" title="_blank" rel="noopener noreferrer" >You can find your nearest court location here.</a>'
              inherit
            />{" "}
            or{" "}
            <Info
              displayText="a family violence support service"
              headingText="Family violence support services"
              bodyText='<a href="https://www.dvrcv.org.au/support-services/victorian-services" title="_blank" rel="noopener noreferrer" >Family violence support services</a>'
              inherit
            />{" "}
            or one of the following state-wide services:
          </p>

          <br />
          <SupportServices
            services={[
              "theOrangeDoor",
              "safeSteps",
              "noToViolence",
              "_1800Respect",
              "umalekBalitProgram",
              "djirraLegal",
              "dardiMunwurro",
              "inTouch",
              "rainbowDoor",
              "sexualAssaultServicesVictoria"
            ]}
          />
          <h2>Legal advice</h2>
          <SupportServices
            services={[
              "victoriaLegalAid",
              "federationOfCommunityLegalCentres",
              "victoriaAboriginalLegalService",
              "djirra",
              "womensLegalServiceVictoria",
              "qLaw",
              "refugeeLegal",
              "seniorsRightsVictoria",
              "villamantaDisabilityRightsLegalCentre",
              "youthlawVictoria",
            ]}
          />
        </Main>
      </Inner>
    </>
  );
};

export default withRouter(ReDecalreComplete);

const Inner = styled.div`
  width: 100%;
  max-width: 1310px;
  position: relative;
  z-index: 1;
  padding: 0;
  background: white;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  ${media.greaterThan("desktop")`
    flex-direction: row;
  `}
`;

const Main = styled.div`
  width: 90%;
  margin: 0 auto;
  max-width: 646px;
`;

const SuccessBox = styled.div`
  padding: 20px 15px;
  background: ${rgba(`#1ba4b2`, 0.15)};
  width: 100%;
  font-size: ${rem(18)};
  line-height: 1.44;
  position: relative;
  margin-bottom: 40px;

  ${media.greaterThan("tablet")`
    padding: 33px 64px;
  `}

  h2 {
    font-size: 22px;
    margin-top: 0;
  }

  > svg {
    height: 25px;
    width: 25px;
    margin-bottom: 5px;
    ${media.greaterThan("tablet")`
        position: absolute;
        top: 33px;
        left: 32px;
        transform: translateX(-50%);

    `};
  }
`;
